import { defineMessages } from "react-intl";

export const messages = defineMessages({
  label: {
    id: "button.takeCareSync.label",
    defaultMessage: "Sync",
    description: "Button label for Take Care Sync",
  },
});
